import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {customMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const fetchModelsByFilters = (filtersObject) => {
  return apiActionCreator({
    'endpoint': '/vehicles/inventory-models',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MODELS_MENU,
      ActionTypes.FETCHED_MODELS_MENU,
      [
        ActionTypes.FETCH_MODELS_MENU_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': filtersObject,
    'contentType': 'application/json',
  });
};

export const fetchModelsLinesByFilters = (filtersObject) => {
  return apiActionCreator({
    'endpoint': '/vehicles/inventory-models-by-line',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_MODELS_BY_LINE_MENU,
      ActionTypes.FETCHED_MODELS_BY_LINE_MENU,
      [
        ActionTypes.FETCH_MODELS_MENU_BY_LINE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'data': filtersObject,
    'contentType': 'application/json',
  });
};

export const fetchUpdateModelsLine = (filtersObject) => {
  return apiActionCreator({
    'endpoint': '/vehicles/inventory-models-by-line',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_UPDATE_MODELS_BY_LINE_MENU,
      [ActionTypes.FETCHED_UPDATE_MODELS_BY_LINE_MENU,
        customMessageBoxInfo({
          'type': 'info',
          'typeValue': 'El cambio se ha ejecutado exitosamente.',
          'hideTime': 200,
        }),
      ],
      [
        ActionTypes.FETCH_UPDATE_MODELS_MENU_BY_LINE_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': filtersObject,
    'contentType': 'application/json',
  });
};

export const updateTable = () => ({
  'type': ActionTypes.UPDATE_TABLE_INVENTORY,
  'payload': null,
});

export const setFilterInventory = (filterObject) => ({
  'type': ActionTypes.SET_FILTER_INVENTORY,
  'payload': filterObject,
});

export const setExcelDataInventory = (lines) => ({
  'type': ActionTypes.SET_EXCEL_DATA_INVENTORY,
  'payload': lines,
});

export const fetchNotificationPrirization = () => {
  return apiActionCreator({
    'endpoint': '/vehicles/priorization-notification',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_NOTIFICATION_PRIORIZATION,
      ActionTypes.FETCHED_NOTIFICATION_PRIORIZATION,
      [
        ActionTypes.FETCH_NOTIFICATION_PRIORIZATION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
    'contentType': 'application/json',
  });
};

export const downloadTransitFile = () => apiActionCreator({
  'endpoint': '/vehicles/vehicle-transit-excel',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_TRANSIT_REPORT,
    ActionTypes.FETCHED_TRANSIT_REPORT,
    [
      ActionTypes.FETCH_TRANSIT_REPORT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchUpdateNotification = (sequence) => {
  return apiActionCreator({
    'endpoint': `/vehicles/priorization-notification-update/${sequence}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_UPDATE_NOTIFICATION_PRIORIZATION,
      [ActionTypes.FETCHED_UPDATE_NOTIFICATION_PRIORIZATION,
        customMessageBoxInfo({
          'type': 'info',
          'typeValue': 'El cambio se ha ejecutado exitosamente.',
          'hideTime': 200,
        }),
      ],
      [
        ActionTypes.FETCH_UPDATE_NOTIFICATION_PRIORIZATION_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
  });
};
